function GetPanels() {
  const panelSquares = window.panels.filter((x) => x.keyGeo && x.keyGeo !== '')
  const newPanels = window.sortByProp(
    panelSquares.filter((x) => x.new),
    'title'
  )
  const resultPanelWithLinks = GetPanelWithLinks(panelSquares, window)
  const others = window.uniqueByProp(panelSquares, newPanels, 'title')
  return [...newPanels, ...resultPanelWithLinks, ...window.sortByProp(others, 'title')]
}
function GetPanelWithLinks(panels, windowReference) {
  return [
    ...panels.map((panel) => (panel.urlToGeo = `${windowReference.geoLink}#/${panel.keyGeo}`)).filter((panelObj) => typeof panelObj !== 'string'),
  ]
}
